import React, { useState } from 'react'
import { Form, Modal, Select, Typography } from 'antd'
import { rateSetStatuses } from '../Form/types/ratesets'
// eslint-disable-next-line @nx/enforce-module-boundaries
import { verticals } from 'packages/rates-research-api/src/schemas/rate-sets-schema'

const BulkStatusUpdateModal = ({ onCancel, onOk, visible, vertical }) => {
  const defaultStatusFrom = 'NEED_QC'
  const defaultStatusTo = 'PUBLISHED'

  const [selectedVertical, setSelectedVertical] = useState(vertical)
  const [selectedStatusFrom, setSelectedStatusFrom] =
    useState(defaultStatusFrom)
  const [selectedStatusTo, setSelectedStatusTo] = useState(defaultStatusTo)

  const handleOk = async () => {
    return onOk({
      vertical: selectedVertical,
      statusFrom: selectedStatusFrom,
      statusTo: selectedStatusTo
    })
  }

  return (
    <Modal
      open={visible}
      onOk={handleOk}
      onCancel={onCancel}
      title="Bulk Status Update"
      okText="Update All"
    >
      <Form name="basic">
        <Form.Item
          help="This will update ALL rate set statues for this vertical"
          label={
            <Typography.Text style={{ width: '55px' }}>
              Vertical
            </Typography.Text>
          }
          style={{ padding: '5px' }}
        >
          <Select
            id="bulk-status-update-vertical"
            data-testid="bulk-status-update-vertical"
            defaultValue={vertical}
            style={{ minWidth: '50%' }}
            onChange={setSelectedVertical}
          >
            {verticals.map(i => (
              <Select.Option key={i.id} value={i.id}>
                {i.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          help="All statuses for this vertical will be updated FROM this status"
          label={
            <Typography.Text style={{ width: '55px' }}>From</Typography.Text>
          }
          style={{ padding: '5px' }}
        >
          <Select
            id="bulk-status-update-statusFrom"
            data-testid="bulk-status-update-statusFrom"
            defaultValue={selectedStatusFrom}
            onChange={setSelectedStatusFrom}
            style={{ minWidth: '50%' }}
          >
            {Object.entries(rateSetStatuses).map(([key, value]) => (
              <Select.Option key={key} value={key}>
                {value.text}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          help="All statuses for this vertical will be updated TO this status"
          label={
            <Typography.Text style={{ width: '55px' }}>To</Typography.Text>
          }
          style={{ padding: '5px' }}
        >
          <Select
            id="bulk-status-update-statusTo"
            data-testid="bulk-status-update-statusTo"
            defaultValue={selectedStatusTo}
            onChange={setSelectedStatusTo}
            style={{ minWidth: '50%' }}
          >
            {Object.entries(rateSetStatuses).map(([key, value]) => (
              <Select.Option key={key} value={key}>
                {value.text}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default BulkStatusUpdateModal
